function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { createEnum, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import PT from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
var DefaultMessages = createEnum({
  skipTo: 'Skip to',
  accessibilityHeader: 'Skip links to main page regions'
});
var arrayOf = PT.arrayOf,
  object = PT.object,
  shape = PT.shape,
  string = PT.string;
var defaults = {
  className: "",
  id: null,
  messages: DefaultMessages
};
var SkipLinks = function SkipLinks(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? defaults.messages : _ref$messages,
    sections = _ref.sections;
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var linkClicked = function linkClicked(event) {
    event.preventDefault();
    var target = event.target.getAttribute("href").substring(1);
    var element = document.getElementById(target);
    element.setAttribute("tabindex", "-1");
    element.focus();
  };
  var links = sections.map(function (link) {
    return /* @__PURE__ */React.createElement("li", {
      key: "skip-link-".concat(link.id)
    }, /* @__PURE__ */React.createElement("a", {
      id: "els-skiplink-".concat(link.id),
      href: "#".concat(link.id),
      className: "c-els-skip-link-group__link",
      "data-testid": "skip-link",
      onClick: linkClicked
    }, compiledMessages.SKIP_TO, " ", link.title || link.id));
  });
  return /* @__PURE__ */React.createElement("nav", {
    "aria-label": compiledMessages.ACCESSIBILITY_HEADER,
    id: id,
    "data-testid": "skip-links",
    className: className
  }, /* @__PURE__ */React.createElement("ol", {
    className: "c-els-skip-link-group"
  }, links));
};
SkipLinks.displayName = "SkipLinks";
SkipLinks.propTypes = {
  className: string,
  id: string,
  messages: object,
  sections: arrayOf(shape({
    /** Provides an ID to link to */
    id: string.isRequired,
    /** Provides link text to be used. ID will be used if this is not provided */
    title: string
  })).isRequired
};
SkipLinks.requiredProps = {
  sections: ValidPropTypes.ARRAY
};
SkipLinks.defaults = defaults;
SkipLinks.DefaultMessages = DefaultMessages;
var RawSkipLinks = SkipLinks;
var SkipLinks$1 = makeErrorBoundComponent(RawSkipLinks);
export { RawSkipLinks, SkipLinks$1 as SkipLinks };
